import React, { useState } from 'react';
import { MdWarningAmber } from 'react-icons/md';

import Dialog        from './Dialog';
import WebAPIProblem from './WebAPIProblem';

/**
 * A small warning for a page whose main work carried on without something
 * from WebAPI (see webAPICall). Clicking it opens a WebAPIProblem dialog, so
 * the problem is visible without getting in the way. Renders nothing while
 * there's no error.
 * @param {Error|null} error    from webAPICall
 * @param {string}     title    what's missing, e.g. 'Working hours not shown'
 * @param {string}     [impact] passed to WebAPIProblem
 * @param {function}   [onRetry] offers "Try again" when given
 */
const WebAPIWarning = ({ error, title, impact, onRetry }) => {

    const [open, setOpen] = useState(false);

    if (!error) {
        return null;
    }

    const retry = () => {
        setOpen(false);
        onRetry();
    };

    return <>
        <button type='button' className='webapi-warning' aria-haspopup='dialog'
            onClick={() => setOpen(true)} >
            <MdWarningAmber aria-hidden='true' /> {title}: find out why
        </button>
        {open &&
            <Dialog title={title} onClose={() => setOpen(false)}
                footer={<>
                    <button type='button' className='chronos-button chronos-button--secondary'
                        onClick={() => setOpen(false)} >Close</button>
                    {onRetry &&
                        <button type='button' className='chronos-button' onClick={retry} >Try again</button>}
                </>} >
                <WebAPIProblem error={error} impact={impact} />
            </Dialog>}
    </>;
};

export default WebAPIWarning;
